"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var env = require("exenv");

require("prop-types");

var React = require("react");

function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}

function _createClass(e, t, n) {
  return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
}

function _defineProperty(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && _setPrototypeOf(e, t);
}

function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? _assertThisInitialized(e) : t;
}

var EventSet = function () {
  function e(t) {
    _classCallCheck(this, e), _defineProperty(this, "handlers", void 0), this.handlers = t.slice(0);
  }

  return _createClass(e, [{
    key: "addHandlers",
    value: function value(t) {
      for (var n = this.handlers.slice(0), r = t.length, o = 0; o < r; o += 1) {
        n.push(t[o]);
      }

      return new e(n);
    }
  }, {
    key: "dispatchEvent",
    value: function value(e, t) {
      var n = this.handlers.length - 1;

      if (t) {
        for (var r = n; r >= 0; r -= 1) {
          this.handlers[r].called || (this.handlers[r].called = !0, this.handlers[r](e));
        }

        for (var o = n; o >= 0; o -= 1) {
          this.handlers[o].called = !1;
        }
      } else {
        (0, this.handlers[n])(e);
      }
    }
  }, {
    key: "hasHandlers",
    value: function value() {
      return this.handlers.length > 0;
    }
  }, {
    key: "removeHandlers",
    value: function value(t) {
      for (var n = [], r = this.handlers.length, o = 0; o < r; o += 1) {
        var a = this.handlers[o];
        -1 === t.indexOf(a) && n.push(a);
      }

      return new e(n);
    }
  }]), e;
}();

function cloneMap(e) {
  var t = new Map();
  return e.forEach(function (e, n) {
    t.set(n, e);
  }), t;
}

function normalizeHandlers(e) {
  return Array.isArray(e) ? e : [e];
}

var isRefObject = function isRefObject(e) {
  return null !== e && "object" === _typeof(e) && e.hasOwnProperty("current");
};

function normalizeTarget(e) {
  return "document" === e ? document : "window" === e ? window : isRefObject(e) ? e.current || document : e || document;
}

var EventPool = function () {
  function e(t, n) {
    _classCallCheck(this, e), _defineProperty(this, "handlerSets", void 0), _defineProperty(this, "poolName", void 0), this.handlerSets = n, this.poolName = t;
  }

  return _createClass(e, [{
    key: "addHandlers",
    value: function value(t, n) {
      var r = cloneMap(this.handlerSets);

      if (r.has(t)) {
        var o = r.get(t);
        r.set(t, o.addHandlers(n));
      } else r.set(t, new EventSet(n));

      return new e(this.poolName, r);
    }
  }, {
    key: "dispatchEvent",
    value: function value(e, t) {
      var n = this.handlerSets.get(e),
          r = "default" === this.poolName;
      n && n.dispatchEvent(t, r);
    }
  }, {
    key: "hasHandlers",
    value: function value() {
      return this.handlerSets.size > 0;
    }
  }, {
    key: "removeHandlers",
    value: function value(t, n) {
      var r = cloneMap(this.handlerSets);
      if (!r.has(t)) return new e(this.poolName, r);
      var o = r.get(t).removeHandlers(n);
      return o.hasHandlers() ? r.set(t, o) : r.delete(t), new e(this.poolName, r);
    }
  }]), e;
}();

_defineProperty(EventPool, "createByType", function (e, t, n) {
  var r = new Map();
  return r.set(t, new EventSet(n)), new EventPool(e, r);
});

var EventTarget = function () {
  function e(t) {
    var n = this;
    _classCallCheck(this, e), _defineProperty(this, "handlers", new Map()), _defineProperty(this, "pools", new Map()), _defineProperty(this, "target", void 0), _defineProperty(this, "createEmitter", function (e) {
      return function (t) {
        n.pools.forEach(function (n) {
          n.dispatchEvent(e, t);
        });
      };
    }), this.target = t;
  }

  return _createClass(e, [{
    key: "addHandlers",
    value: function value(e, t, n) {
      if (this.pools.has(e)) {
        var r = this.pools.get(e);
        this.pools.set(e, r.addHandlers(t, n));
      } else this.pools.set(e, EventPool.createByType(e, t, n));

      this.handlers.has(t) || this.addTargetHandler(t);
    }
  }, {
    key: "hasHandlers",
    value: function value() {
      return this.handlers.size > 0;
    }
  }, {
    key: "removeHandlers",
    value: function value(e, t, n) {
      if (this.pools.has(e)) {
        var r = this.pools.get(e).removeHandlers(t, n);
        r.hasHandlers() ? this.pools.set(e, r) : this.pools.delete(e), 0 === this.pools.size && this.removeTargetHandler(t);
      }
    }
  }, {
    key: "addTargetHandler",
    value: function value(e) {
      var t = this.createEmitter(e);
      this.handlers.set(e, t), this.target.addEventListener(e, t, !0);
    }
  }, {
    key: "removeTargetHandler",
    value: function value(e) {
      this.handlers.has(e) && (this.target.removeEventListener(e, this.handlers.get(e), !0), this.handlers.delete(e));
    }
  }]), e;
}(),
    EventStack = function () {
  function e() {
    var t = this;
    _classCallCheck(this, e), _defineProperty(this, "targets", new Map()), _defineProperty(this, "getTarget", function (e) {
      var n = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
          r = normalizeTarget(e);
      if (t.targets.has(r)) return t.targets.get(r);
      if (!n) return null;
      var o = new EventTarget(r);
      return t.targets.set(r, o), o;
    }), _defineProperty(this, "removeTarget", function (e) {
      t.targets.delete(normalizeTarget(e));
    });
  }

  return _createClass(e, [{
    key: "sub",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};

      if (env.canUseDOM) {
        var r = n.target,
            o = void 0 === r ? document : r,
            a = n.pool,
            s = void 0 === a ? "default" : a;
        this.getTarget(o).addHandlers(s, e, normalizeHandlers(t));
      }
    }
  }, {
    key: "unsub",
    value: function value(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};

      if (env.canUseDOM) {
        var r = n.target,
            o = void 0 === r ? document : r,
            a = n.pool,
            s = void 0 === a ? "default" : a,
            i = this.getTarget(o, !1);
        i && (i.removeHandlers(s, e, normalizeHandlers(t)), i.hasHandlers() || this.removeTarget(o));
      }
    }
  }]), e;
}(),
    instance = new EventStack(),
    EventStack$1 = function (e) {
  function t() {
    return _classCallCheck(this, t), _possibleConstructorReturn(this, _getPrototypeOf(t).apply(this, arguments));
  }

  return _inherits(t, React.PureComponent), _createClass(t, [{
    key: "componentDidMount",
    value: function value() {
      this.subscribe(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e) {
      this.unsubscribe(e), this.subscribe(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.unsubscribe(this.props);
    }
  }, {
    key: "subscribe",
    value: function value(e) {
      var t = e.name,
          n = e.on,
          r = e.pool,
          o = e.target;
      instance.sub(t, n, {
        pool: r,
        target: o
      });
    }
  }, {
    key: "unsubscribe",
    value: function value(e) {
      var t = e.name,
          n = e.on,
          r = e.pool,
          o = e.target;
      instance.unsub(t, n, {
        pool: r,
        target: o
      });
    }
  }, {
    key: "render",
    value: function value() {
      return null;
    }
  }]), t;
}();

_defineProperty(EventStack$1, "defaultProps", {
  pool: "default",
  target: "document"
}), EventStack$1.propTypes = {}, exports.instance = instance, exports.default = EventStack$1;